import { Link, type Location, useLocation } from 'react-router';

import { Button, Circle, Flex, Heading, HStack, Text, VStack } from '@chakra-ui/react';

import { Lock } from '@enterprise/ui';

import { useApplicationStore } from '@hooks/application/application-store.hook';

const Denied = () => {
  const user = useApplicationStore(({ user }) => {
    return user;
  });
  const location = useLocation() as Location<{ from: string } | undefined>;

  const previousPath = location.state?.from ?? '/datastream/packagemanager';

  return (
    <Flex
      alignItems="center"
      bg="hsp.50"
      justifyContent="center"
      minH="100vh"
      px={6}>
      <VStack
        bg="white"
        border="1px solid"
        borderColor="hsp.100"
        borderRadius="xl"
        maxW="420px"
        p={10}
        spacing={4}
        textAlign="center"
        w="full">
        <Circle
          bg="hsp.50"
          size="72px">
          <Lock
            color="var(--chakra-colors-hsp-500)"
            size="3x"
          />
        </Circle>

        <Heading
          fontSize="xl"
          fontWeight="medium">
          This page is locked
        </Heading>

        <Text
          color="hsp.500"
          fontSize="xs"
          fontWeight="semibold"
          letterSpacing="wide">
          Signed in as {user?.emailAddress}
        </Text>

        <Text
          color="gray.500"
          fontSize="sm"
          lineHeight="tall">
          You need permission to access this page.
        </Text>

        <HStack pt={2}>
          <Button
            as={Link}
            colorScheme="hsp"
            size="sm"
            to="/datastream/packagemanager">
            Take me home
          </Button>
          <Button
            as={Link}
            colorScheme="hsp"
            size="sm"
            to={previousPath}
            variant="outline">
            Go back
          </Button>
        </HStack>
      </VStack>
    </Flex>
  );
};

export default Denied;
